import React, {
  Fragment,
  useContext,
  forwardRef,
  useState,
  useEffect,
} from "react";
import { Grid, CircularProgress } from "@material-ui/core";
import MaterialTable from "material-table";
import { LangContext } from "../../Context/Langcontext";

import {
  MdAddBox,
  MdCheck,
  MdClear,
  MdDeleteSweep,
  MdChevronRight,
  MdEdit,
  MdSave,
  MdFilterList,
  MdFirstPage,
  MdLastPage,
  MdChevronLeft,
  MdSearch,
  MdRemove,
  MdViewColumn,
} from "react-icons/md";

const TableData = ({ columns, data, filter, Iconsort }) => {
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const [fetch, setfetch] = useState(false);
  const [loading, setloading] = useState(false);

  const tableIcons = {
    Add: forwardRef((props, ref) => <MdAddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <MdCheck {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <MdClear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <MdDeleteSweep {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <MdChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <MdEdit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <MdSave {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <MdFilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <MdFirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <MdLastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => (
      <MdChevronRight {...props} ref={ref} />
    )),
    PreviousPage: forwardRef((props, ref) => (
      <MdChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <MdClear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <MdSearch {...props} ref={ref} />),
    SortArrow: Iconsort,
    ThirdStateCheck: forwardRef((props, ref) => (
      <MdRemove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => (
      <MdViewColumn {...props} ref={ref} />
    )),
  };

  useEffect(() => {
    if (!fetch) {
      setloading(true);
      setTimeout(() => {
        setloading(false);
      }, 2000);
      setfetch(true);
    } else {
    }
  }, [fetch]);
  return (
    <Fragment>
      <Grid item xs={12}>
        {loading ? (
          <div style={{ textAlign: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <div style={{ margin: "2rem" }}>
            <MaterialTable
              icons={tableIcons}
              style={{
                borderRadius: 8,
                boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
                WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
                MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
                backgroundColor: "#f9f9f9",
              }}
              options={{
                sorting: true,
                filtering: filter,
                paginationType: "stepped",
                toolbar: false,
                headerStyle: {
                  fontSize: "1rem",
                  fontWeight: 400,
                  color: "#595A5A",
                  backgroundColor: "#f9f9f9",
                  textAlign: "center",
                  lineHeight: "1rem",
                  whiteSpace: "nowrap",
                  borderRadius: 15,
                },
                rowStyle: (rowData, index) => ({
                  backgroundColor: index % 2 === 1 ? "#f9f9f9" : "#FFFFFF",
                }),
                cellStyle: (rowData, index) => ({
                  fontWeight: 200,
                  textAlign: "center",
                  fontSize: "1rem",
                  borderBottom: "unset",
                  whiteSpace: "nowrap",
                  padding: 8,
                }),
                filterCellStyle: {
                  textAlign: "center",
                },
                pageSizeOptions: [10, 20, 50],
                pageSize: 10,
                emptyRowsWhenPaging: false,
                actionsColumnIndex: -1,
              }}
              localization={{
                pagination: {
                  labelRowsSelect: lang.Rows,
                  nextTooltip: lang.NextPage,
                  firstTooltip: lang.FirstPage,
                  previousTooltip: lang.PreviousPage,
                  lastTooltip: lang.LastPage,
                },
                body: {
                  emptyDataSourceMessage: lang.Norecord,
                },
              }}
              columns={columns}
              data={data}
            />
          </div>
        )}
      </Grid>
    </Fragment>
  );
};

export default TableData;
